var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.081,
    height: 11.654,
    viewBox: "0 0 11.081 11.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-new",
    d: "M3.081,0,.885,2.119v9.535H6.77V10.641H1.9v-7.8H3.824V1.013h4.3v3.04h1.02V0ZM7.672,4.941V7.36H5.252V9.235h2.42v2.419H9.546s-.6-1.814,0-2.419,2.42,0,2.42,0V7.36H9.546V4.941H7.672Z",
    transform: "translate(-0.885)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNew);
export default __webpack_public_path__ + "static/media/file-new.6a52d01103b32874d21fe9a3c33962a2.svg";
export { ForwardRef as ReactComponent };